export const DEFAULT_RISKS = [
    {
        color: '#505A5C',
        label: 'Very Low Risk',
        backgroundColor: '#A9FE95'
    },
    {
        color: '#505A5C',
        label: 'Low Risk',
        backgroundColor: '#D4F19B'
    },
    {
        color: '#505A5C',
        label: 'Medium Risk',
        backgroundColor: '#FFE5A0'
    },
    {
        color: '#505A5C',
        label: 'High Risk',
        backgroundColor: '#FFAF91'
    },
    {
        color: '#505A5C',
        label: 'Very High Risk',
        backgroundColor: '#FF7981'
    },
    {
        color: '#505A5C',
        label: 'Unknown Risk',
        backgroundColor: '#C4C4C4'
    }
];
